import * as d3 from 'd3'
export default {
  methods: {

    pagination() {
      this.page = {
        len: this.setData.length,
        sys: 30,
        total: 0,
      }
      this.page.total = Math.ceil(this.page.len/this.page.sys)

      let paging = this.canvasSystems
      .append('g')
      .attr('transform', `translate(${this.system.px}, ${this.system.py})`)

      paging
      .append('image')
      .attr('id', `LIST_JPG`)
      .attr('xlink:href', this.current.list == 'JPG' ? this.HOST + '/icon/list_JPG_on.svg' : this.HOST + '/icon/list_JPG_off.svg')
      .attr('x', 0).attr('y', -2.5).attr('width', 25).attr('opacity', 1)
      .attr('cursor', this.current.list=='JPG' ? 'default' : 'pointer')
      .on('mouseover', ()=> {
        if(this.current.list=='JPG') return
        d3.select(`#LIST_JPG`).transition().duration(50).attr('opacity', .5)
      })
      .on('mouseout', ()=> {
        if(this.current.list=='JPG') return
        d3.select(`#LIST_JPG`).transition().duration(50).attr('opacity', 1)
      })
      .on('click', ()=> {
        if(this.current.list=='JPG') return
        this.current.list = 'JPG'
        this.canvasSystems.remove()
        this.draw_SystemList()
      })

      paging
      .append('image')
      .attr('id', `LIST_ITEM`)
      .attr('xlink:href', this.current.list == 'ITEM' ? this.HOST + '/icon/list_ITEM_on.svg' : this.HOST + '/icon/list_ITEM_off.svg')
      .attr('x', 40).attr('y', -2.5).attr('width', 25).attr('opacity', 1)
      .attr('cursor', this.current.list=='ITEM' ? 'default' : 'pointer')
      .on('mouseover', ()=> {
        if(this.current.list=='ITEM') return
        d3.select(`#LIST_ITEM`).transition().duration(50).attr('opacity', .5)
      })
      .on('mouseout', ()=> {
        if(this.current.list=='ITEM') return
        d3.select(`#LIST_ITEM`).transition().duration(50).attr('opacity', 1)
      })
      .on('click', ()=> {
        if(this.current.list=='ITEM') return
        this.current.list = 'ITEM'
        this.canvasSystems.remove()
        this.draw_SystemList()
      })
      

      let x_ = 100
      if(this.page.total > 1) {

        paging
        .append('rect')
        .attr('x', 87).attr('y', -5).attr('rx', 5).attr('ry', 5)
        .attr('width', this.page.total*35+10).attr('height', 30)
        .attr('fill', '#fff').attr('stroke', '#E0E0DF').attr('stroke-width', .5)

        for(let i=1; i<=this.page.total; i++) {

          let pageSys = paging
          .append('g')
          .attr('id', `PAGE_GROUP_${i}`)
          .attr('transform', `translate(${x_}, 0)`)
          .attr('cursor', this.current.page==i ? 'default' : 'pointer')
          .on('mouseover', ()=> {
            if(this.current.page==i) return
            d3.select(`#PAGE_GROUP_${i}`).transition().duration(50).attr('transform', `translate(${(i-1)*35 + 97.5}, ${-2.5}) scale(1.3)`)
            d3.select(`#PAGE_BOX_${i}`).transition().duration(50).attr('stroke', '#757575')
            d3.select(`#PAGE_NO_${i}`).transition().duration(50).attr('fill', '#757575')
          })
          .on('mouseout', ()=> {
            if(this.current.page==i) return
            d3.select(`#PAGE_GROUP_${i}`).transition().duration(300).attr('transform', `translate(${i*35+65}, ${0}) scale(1)`)
            d3.select(`#PAGE_BOX_${i}`).transition().duration(50).attr('stroke', '#bcbcbc')
            d3.select(`#PAGE_NO_${i}`).transition().duration(50).attr('fill', '#bcbcbc')
          })
          .on('click', ()=> {
            if(this.current.page==i) return
            this.current.page = i
            this.canvasSystems.remove()
            this.draw_SystemList()
          })

          pageSys
          .append('rect')
          .attr('id', `PAGE_BOX_${i}`)
          .attr('x', 0).attr('y', 0).attr('rx', 4).attr('ry', 4)
          .attr('width', 20).attr('height', 20)
          .attr('fill', '#fff').attr('stroke', this.current.page==i ? '#44A9DF' : '#bcbcbc').attr('stroke-width', this.current.page==i ? 1 : .5)

          pageSys
          .append('text')
          .attr('id', `PAGE_NO_${i}`)
          .attr('transform', `translate(10, 14)`)
          .attr('font-size', 12).attr('fill', this.current.page==i ? '#44A9DF' : '#bcbcbc').attr('text-anchor', 'middle')
          .text(i)

          x_ += 35
        }
      }
      
      
    },
    
  }
}